<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 19 12"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.076 2.66688C10.4583 3.03504 10.4583 3.63195 10.076 4.00012L2.46147 11.332C2.07912 11.7002 1.45919 11.7002 1.07684 11.332C0.694484 10.9638 0.694484 10.3669 1.07684 9.99876L8.69133 2.66688C9.07369 2.29871 9.69361 2.29871 10.076 2.66688Z" :fill="fill"/>
    <rect :fill="fill" height="1.92217" rx="0.961085" transform="matrix(-0.720348 -0.693613 0.720348 -0.693613 16.9999 12)" width="12.4948"/>
    <rect :fill="fill" height="2" rx="1" width="19"/>
  </svg>
</template>

<script>
export default {
  name: 'ScrollTop',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
